import { Component, Vue } from "vue-property-decorator";

@Component
export class GlobalMixin extends Vue {
  get marginTop(): object {
    if (this.$vuetify.breakpoint.xl) return { "margin-top": "calc(100vh/5)" };
    else if (this.$vuetify.breakpoint.lg)
      return { "margin-top": "calc(100vh/5)" };
    else return { "margin-top": "calc(100vh/20)" };
  }

  get marginContent(): object {
    if (this.$vuetify.breakpoint.xl) return { "margin-top": "calc(100vh/5)" };
    else if (this.$vuetify.breakpoint.lg && this.$vuetify.breakpoint.md)
      return { "margin-top": "calc(100vh/5)" };
    else return { "margin-top": "calc(100vh/18)" };
  }

  image(path: string): string {
    return this.$vuetify.theme.dark
      ? require("@/assets/dark/" + path)
      : require("@/assets/" + path);
  }

  get imageSize(): string {
    if (this.$vuetify.breakpoint.xl) return "700";
    else if (this.$vuetify.breakpoint.lg) return "600";
    else if (this.$vuetify.breakpoint.md) return "500";
    else return "300";
  }

  get kanbanSize(): string {
    if (this.$vuetify.breakpoint.xl) return "750";
    else if (this.$vuetify.breakpoint.lg) return "600";
    else return "450";
  }
  redirect(path: string): void {
    path === "auth"
      ? window.open(process.env.VUE_APP_ACCESS_MANAGER, "_blank")
      : window.open(path, "_blank");
  }
}
